export default ({children}) => children;

// Swipeable View is available just on Android/iOS for now.
